// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CCBannerController from "./cc_banner_controller"
application.register("cc-banner", CCBannerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InterfacesController from "./interfaces_controller"
application.register("interfaces", InterfacesController)

import PanelsController from "./panels_controller"
application.register("panels", PanelsController)
